import Component from '../classes/component';

const SELECTORS = {
  content: '.text-fitter-content',
};

class TextFitter extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private readonly _settings = {
    maxFontSize: 16,
  };

  private _handleResize() {
    const content = this._getChild('content');
    const contentStyles = window.getComputedStyle(content);
    const ratio = content.offsetWidth / this.container.offsetWidth;
    const fontSize = Number(contentStyles.fontSize.replace('px', ''));
    const newFontSize = Math.min(Math.floor(fontSize / ratio), this._settings.maxFontSize);

    content.style.fontSize = `${newFontSize}px`;
  }

  protected _onEnter() {
    this._handleResize();
    document.fonts.ready.then(this._handleResize.bind(this));
    this._addListener(window, 'resize', this._handleResize, 500);
    this._addListener(window, 'orientationchange', this._handleResize, 500);
  }
}

export default TextFitter;
